/** Variable overlays (e.g. Toasts) read to offset left of an open Drawer. */
export const DRAWER_WIDTH_CSS_VAR = '--ds-drawer-width';
/** Reset value when no Drawer is open. */
export const DRAWER_WIDTH_RESET = '0px';
/** Drawer width while open. */
export const DRAWER_WIDTH = 'var(--ds-vw-38)';
